<div class="ui-payments-report">
    <div class="ui-payments-report-content" mat-dialog-content>
      <div class="ui-payments-report-details">
        <object type="image/svg+xml" data="assets/images/icons/payment-add.svg"></object>
        <h3 class="ui-title">Reportar un pago</h3>
        <p>Indicanos la fecha en la que realizaste el pago para poder imputar el importe en tu cuenta.</p>
      </div>
  
      <form class="ui-dialog" [formGroup]="formData">
        <div class="ui-form">
            <div class="ui-form-row">
                <mat-form-field class="ui-input">
                    <mat-label>Fecha de pago</mat-label>
                    <input matInput type="date" formControlName="date">
                    <mat-error *ngIf="formHasError('date', 'validate')">{{formHasError('date', 'message')}}</mat-error>
                </mat-form-field>
            </div>
        </div>
      </form>
    </div>
  
    <div class="ui-payments-report-actions" mat-dialog-actions>
      <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
      <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Reportar pago</button>
    </div>
</div>